import { colors } from "@itandi/itandi-bb-ui";
import { Button } from "@itandi/itandi-bb-ui/Button";
import { Chip } from "@itandi/itandi-bb-ui/Chip";
import { useNotification } from "@itandi/itandi-bb-ui/NotificationBarStore";
import Link from "next/link";
import React from "react";
import { SERVER_ERROR_MESSAGE } from "~/constants/AppConst";
import { useMessages } from "~/hooks/deals/useMessages";
import { useDeals } from "~/hooks/useDeals";
import { useIdQueryHandler } from "~/hooks/useIdQueryHandler";
import { isWithVendorDeal } from "~/models/Deal";
import { getOriginVendor } from "~/models/DealVendorCompany";
import {
	getUnreadCount,
	UPDATE_TEMPORARY_UNREAD_MESSAGE
} from "~/models/Message";
import { PATH as DEAL_DETAIL_PATH } from "~/pages/deals/[id]/detail";
import { PATH as DEAL_MESSAGES_PATH } from "~/pages/deals/[id]/messages";
import { isSuccess } from "~/utils/api/api_handler";
import { postTemporaryUnread } from "~/utils/api/deals/Message";
import Styles from "./DealMainSpLinks.module.scss";

type Props = {
	isAdmin: boolean;
};

export const DealMainSpLinksClient: React.FC<Props> = ({ isAdmin }: Props) => {
	const { notify } = useNotification();
	const id = useIdQueryHandler();
	const { data: deal, mutate: mutateDeal } = useDeals().show(id);
	const { data: messages } = useMessages().index(id);
	const unreadMessageCount = React.useMemo((): number => {
		if (messages === null) {
			return 0;
		}
		return getUnreadCount(messages, "maintenance_company");
	}, [messages]);
	if (deal === null) {
		return null;
	}
	const handleTemporaryUnread = async (): Promise<void> => {
		const result = await postTemporaryUnread(deal.id);
		if (isSuccess(result)) {
			notify({ content: UPDATE_TEMPORARY_UNREAD_MESSAGE, variant: "success" });
			await mutateDeal?.();
			return;
		}
		notify({ content: SERVER_ERROR_MESSAGE, variant: "error" });
	};
	const unread =
		!!deal.messageSummaryUnread?.unread ||
		!!deal.messageSummaryUnread?.displayUnread;
	const unreadChipText =
		unreadMessageCount > 0 ? `未読${unreadMessageCount}` : "未読";
	return (
		<div className={Styles.SPDealDetail}>
			<Link
				className={Styles.SPDealDetailLink}
				href={DEAL_DETAIL_PATH(deal.id)}
			>
				案件内容
			</Link>
			{isWithVendorDeal(deal) && getOriginVendor(deal) !== null && (
				<>
					<Link
						className={Styles.SPDealDetailLink}
						href={DEAL_MESSAGES_PATH(deal.id)}
					>
						施工会社とチャット
						{unread ? (
							<Chip
								background={colors["semantic-negative"]}
								borderColor={null}
								label={unreadChipText}
								textColor={colors["itandi-white"]}
							/>
						) : null}
					</Link>
					{messages && messages.length > 0 && !unread ? (
						<Button
							disabled={isAdmin}
							marginTop="1rem"
							onClick={handleTemporaryUnread}
							variant="tertiary"
							width="fill"
						>
							チャットに未読ラベルを付ける
						</Button>
					) : null}
				</>
			)}
		</div>
	);
};
